import { UserPermissionType } from '../../../../../data-access/gql-types/graphql';

export const permissionEnumForActionTab = {
  0: UserPermissionType.ActionsCreate,
  1: UserPermissionType.ActionsCreate,
  2: UserPermissionType.TriggersCreate,
};

export const actionTabKeys = ['basic', 'advanced', 'automations', 'events'];
